import { Product } from 'data/product'

export const routeChangeEvent = () => {
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'route-change' })
  }
}

type AnalyticsAction = 'click' | 'scroll'
type AnalyticsCategory = 'Shopify API' | 'Internal Event'
type AnalyticsLabel =
  | 'addToCart'
  | 'checkout'
  | 'closeCart'
  | 'openCart'
  | 'removeFromCart'
  | Product['slug']

const trackEvent = (
  _category: AnalyticsCategory,
  _action: AnalyticsAction,
  label: AnalyticsLabel
) => {
  if (label === 'addToCart' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }

  if (label === 'addToCart' && window.dataLayer) {
    window.dataLayer.push({ event: 'add_to_cart' })
  }
}

export const trackInternalEvent = (
  label: AnalyticsLabel,
  action: AnalyticsAction = 'click'
) => {
  trackEvent('Internal Event', action, label)
}

export const trackShopifyEvent = (label: AnalyticsLabel) => {
  trackEvent('Shopify API', 'click', label)
}

// Opt-in GA4 debug mode, gated on a GATSBY_ flag (build-time inlined here, so
// toggling client logging needs a redeploy; the webhook reads the same flag at
// runtime to also tag its MP hit with debug_mode → GA4 DebugView).
const GA4_DEBUG = process.env.GATSBY_GA4_DEBUG_MODE === 'true'

export const debugLog = (
  message: string,
  data?: Record<string, unknown>
): void => {
  if (!GA4_DEBUG) return
  // eslint-disable-next-line no-console
  console.warn(`[ga4-attribution] ${message}`, data ?? '')
}
